import UserType from "../constants/UserType";
import { TaxDetails } from "../interfaces/Payment";

// TAX: 0.029 (2.9% - Stripe Fee)
// SERVICE CHARGE: 0.1 (10%) for Chef, 0.05 (5%) for Client

const formatFloat = (totalAmount: number) => {
  return Math.floor(totalAmount * 100) / 100;
};

const calculateTax = (totalAmount: number, tax_amount: number) => {
  return formatFloat(totalAmount * tax_amount) + 0.6;
};

const calculateServiceCharge = (
  totalAmount: number,
  service_charge: number
) => {
  return formatFloat(totalAmount * service_charge);
};

const calculateGrossTotal = (
  totalAmount: number,
  tax_amount: number,
  service_charge: number,
  userType: UserType
) => {
  if (userType === UserType.Chef) {
    return formatFloat(
      totalAmount -
        calculateTax(totalAmount, tax_amount) -
        calculateServiceCharge(totalAmount, service_charge)
    );
  } else {
    return formatFloat(
      totalAmount +
        calculateTax(totalAmount, tax_amount) +
        calculateServiceCharge(totalAmount, service_charge)
    );
  }
};

const calculateInitialGrossTotal = (
  totalAmount: number,
  tax_amount: number,
  service_charge: number,
  userType: UserType
) => {
  if (userType === UserType.Chef) {
    return formatFloat(
      (totalAmount - totalAmount * 0.1 - totalAmount * 0.029) * 0.25 - 0.3
    );
  } else {
    return formatFloat(
      (totalAmount + totalAmount * 0.05 + totalAmount * 0.029) * 0.25 + 0.3
    );
  }
};

const calculateFinalGrossTotal = (
  totalAmount: number,
  tax_amount: number,
  service_charge: number,
  userType: UserType
) => {
  if (userType === UserType.Chef) {
    return formatFloat(
      (totalAmount - totalAmount * 0.1 - totalAmount * 0.029) * 0.75 - 0.3
    );
  } else {
    return formatFloat(
      (totalAmount + totalAmount * 0.05 + totalAmount * 0.029) * 0.75 + 0.3
    );
  }
};

const calculateDepositPayment = (
  totalAmount: number,
  deposit_percentage: number
) => {
  return formatFloat(totalAmount * deposit_percentage);
};
const calculateBalance = (totalAmount: number, deposit_percentage: number) => {
  return formatFloat(totalAmount * (1 - deposit_percentage));
};

export {
  calculateTax,
  calculateServiceCharge,
  calculateGrossTotal,
  calculateInitialGrossTotal,
  calculateFinalGrossTotal,
  calculateDepositPayment,
  calculateBalance,
  formatFloat,
};
